interface IConfig {
  locales: string[];
  defaultLocale: string;
}

export const Config: IConfig = {
  locales: ['en', 'pl', 'uk', 'de', 'el', 'nl', 'bg', 'cs', 'da', 'es', 'et', 'fi', 'fr', 'hu', 'it', 'lt', 'lv', 'pt', 'ro', 'sk', 'sl', 'sv'],
  defaultLocale: 'en',
}
